import orderDictionary from '../../ru/order/order.dic.json';

export const orderNS = {
  ORDER: orderDictionary,
};

export const orderNamespaces = ['ORDER'];
